import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AuthService, AuthRedirectService, SemanticPathService, AuthStorageService, OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SecureGuard  {
  private _successMsgSource = new BehaviorSubject<boolean>(true);
  successMsg$ = this._successMsgSource.asObservable();
  //AuthToken
  authToken: any;
  constructor(
    protected authService: AuthService,
    protected authRedirectService: AuthRedirectService,
    protected router: Router,
    protected semanticPathService: SemanticPathService,
    private authStorageService: AuthStorageService,
    private http: HttpClient, private occService: OccEndpointsService,
  ) { }
  sendSuccessMsg(message: boolean) {
    this._successMsgSource.next(message);
  }
  canActivate(): Observable<boolean | UrlTree> {
    return this._successMsgSource;
  }
  updatePassword(data: any) {
    //need to bind authtoken in header
    this.authToken = this.getnewAccessToken();
    return this.http.post(this.occService.buildUrl(`kblogin/securepassword?newPassword=${data?.newpassword}&token=${this.authToken}`), data);
  }

  getnewAccessToken() {
    let accessToken;
    this.authStorageService.getToken().subscribe((x) => {
      accessToken = x.access_token;
    });
    return accessToken;
  }
}